var _circle, _mask, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectionMissAttainGoal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#FFD8D8"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1335_303",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 16L23.751 30.5816L23.0108 32.1545C19.7376 39.1102 24.8126 47.1074 32.5 47.1074C40.1874 47.1074 45.2624 39.1102 41.9892 32.1545L41.2489 30.5816L32.5 16Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4547 42.7448C33.4255 42.833 34.8967 42.6773 36.193 41.9119C37.5164 41.1305 38.6214 39.7325 38.8306 37.4316L37.8347 37.3411C37.655 39.3174 36.7348 40.4307 35.6846 41.0508C34.6074 41.6868 33.3567 41.8227 32.5453 41.7489L32.4547 42.7448ZM23.751 30.5816L22.8936 30.0671L22.8677 30.1102L22.8462 30.1558L23.751 30.5816ZM32.5 16L33.3575 15.4855L32.5 14.0563L31.6425 15.4855L32.5 16ZM23.0108 32.1545L23.9157 32.5803L23.0108 32.1545ZM41.9892 32.1545L42.894 31.7287L41.9892 32.1545ZM41.2489 30.5816L42.1538 30.1558L42.1323 30.1102L42.1064 30.0671L41.2489 30.5816ZM24.6085 31.0961L33.3575 16.5145L31.6425 15.4855L22.8936 30.0671L24.6085 31.0961ZM23.9157 32.5803L24.6559 31.0074L22.8462 30.1558L22.106 31.7287L23.9157 32.5803ZM32.5 46.1074C25.5456 46.1074 20.9545 38.8728 23.9157 32.5803L22.106 31.7287C18.5206 39.3477 24.0796 48.1074 32.5 48.1074V46.1074ZM41.0843 32.5803C44.0455 38.8728 39.4544 46.1074 32.5 46.1074V48.1074C40.9204 48.1074 46.4794 39.3477 42.894 31.7287L41.0843 32.5803ZM40.3441 31.0074L41.0843 32.5803L42.894 31.7287L42.1538 30.1558L40.3441 31.0074ZM31.6425 16.5145L40.3915 31.0961L42.1064 30.0671L33.3575 15.4855L31.6425 16.5145Z",
    fill: "#D91F05",
    mask: "url(#path-2-inside-1_1335_303)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectionMissAttainGoal);
export default __webpack_public_path__ + "static/media/projection_miss_attain_goal.58c8e7278128dd69f985d21d176bdd53.svg";
export { ForwardRef as ReactComponent };